export default function Methodology() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico estratégico do negócio e mercado',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Definição de objetivos, métricas e prioridades',
      icon: 'ri-target-line'
    },
    {
      number: '03',
      title: 'Execução integrada das frentes de marketing',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Monitoramento contínuo e ajustes estratégicos',
      icon: 'ri-radar-line'
    },
    {
      number: '05',
      title: 'Relatórios focados em tomada de decisão',
      icon: 'ri-file-chart-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Como estruturamos crescimento previsível
          </h2>
        </div>

        <div className="space-y-4 sm:space-y-6 mb-10 sm:mb-12 md:mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm p-6 sm:p-8 rounded-xl border border-gray-700 hover:border-teal-500 transition-all group hover:bg-gray-800"
            >
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
                <div className="flex items-center gap-4 sm:gap-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-600 rounded-lg group-hover:scale-110 transition-transform shrink-0">
                    <i className={`${step.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                  <span className="text-4xl sm:text-5xl md:text-6xl font-bold text-teal-600/30 shrink-0">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-white leading-snug flex-1">
                  {step.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <p className="text-base sm:text-lg md:text-xl text-center text-teal-400 font-semibold">
          Crescimento não é improviso. É método.
        </p>
      </div>
    </section>
  );
}
